var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 27
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".TC_svg__a{fill:#0a9e01}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "TC_svg__a",
    d: "M21 0v7h-7v14H7V7H0V0zM28 0h14v7H28zM42 14v7H21V7h7v7z"
  })));
}
export default __webpack_public_path__ + "assets/static/media/TC.a84a90ee.svg";
export { SvgTc as ReactComponent };